import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';

export const useShowKpiSetting = () => {
  const { userInfo, workbenchMode } = useInitialInfoStore();
  return userInfo?.app_spi && !workbenchMode;
};
